var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-container" }, [
    _c(
      "div",
      { staticStyle: { "margin-bottom": "20px" } },
      [
        _c(
          "el-button",
          {
            attrs: { icon: "el-icon-back", size: "small", plain: "" },
            on: {
              click: function ($event) {
                return _vm.closeWindow(false)
              },
            },
          },
          [
            _vm._v(
              _vm._s(_vm.$t("userManage.ReturnListTemporaryWorkerAccounts"))
            ),
          ]
        ),
      ],
      1
    ),
    _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
      _c("div", { staticClass: "create-title" }, [
        _vm._v(_vm._s(_vm.$t("userManage.ReapplyTemporaryWorkerAccount"))),
      ]),
      _c("div", { staticStyle: { "font-size": "14px" } }, [
        _vm._v(_vm._s(_vm.$t("userManage.AccountHasExpired"))),
      ]),
    ]),
    _c("div", { staticClass: "reapply-container" }, [
      _c("div", { staticClass: "reapply-title-con" }, [
        _c("div", { staticClass: "reapply-title" }, [
          _vm._v(_vm._s(_vm.$t("userManage.ReapplyForAnAccount"))),
        ]),
        _c("div", { staticStyle: { "font-size": "14px" } }, [
          _vm._v(_vm._s(_vm.$t("userManage.TheBasicPersonnelInformation"))),
        ]),
      ]),
      _c("div", { staticStyle: { padding: "20px" } }, [
        _c("div", { staticClass: "reapply-warning-tips" }, [
          _vm._v(" " + _vm._s(_vm.$t("userManage.TheOriginalAccount")) + " "),
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.formData.username)),
          ]),
          _vm._v(" " + _vm._s(_vm.$t("userManage.hasExpired")) + " "),
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.formData.expireAt)),
          ]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("userManage.AfterTheReapplicationIsApproved")) +
              " "
          ),
        ]),
        _c(
          "div",
          { staticClass: "rest-form" },
          [
            _c(
              "el-form",
              {
                ref: "formDataRef",
                attrs: { model: _vm.formData, "label-position": "top" },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.compellation"),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.formData.realName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "realName", $$v)
                                },
                                expression: "formData.realName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "CPF" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.formData.cpf,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "cpf", $$v)
                                },
                                expression: "formData.cpf",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("collectionCenter.val13") },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.formData.siteName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "siteName", $$v)
                                },
                                expression: "formData.siteName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("home.position") } },
                          [
                            _c("el-input", {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.formData.positionName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "positionName", $$v)
                                },
                                expression: "formData.positionName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "userManage.NumberOfDaysTheAccountIsValid"
                              ),
                              prop: "validDays",
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("userManage.notNull"),
                                  trigger: ["change", "blur"],
                                },
                                {
                                  validator: _vm.checkNumber,
                                  trigger: ["change", "blur"],
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.formData.validDays,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "validDays", $$v)
                                },
                                expression: "formData.validDays",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "userManage.NumberOfDaysTheAccountIsValid"
                              ),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.formData.rules,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "rules", $$v)
                                },
                                expression: "formData.rules",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("userManage.ReasonForApplication"),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                rows: 3,
                                maxlength: "200",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.formData.reason,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "reason", $$v)
                                },
                                expression: "formData.reason",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "reapply-rules" }, [
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.$t("userManage.ReapplyRules")) + "："),
          ]),
          _vm._v(
            " " + _vm._s(_vm.$t("userManage.ReapplyRuleDescription")) + " "
          ),
        ]),
      ]),
      _c(
        "div",
        { staticStyle: { padding: "20px", "border-top": "1px solid #ddd" } },
        [
          _c(
            "el-button",
            {
              attrs: { plain: "" },
              on: {
                click: function ($event) {
                  return _vm.closeWindow(false)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("userManage.cancel")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: { type: "primary" },
              on: { click: _vm.submitANewApplication },
            },
            [_vm._v(_vm._s(_vm.$t("userManage.SubmitANewApplication")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }